// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ld-2";
export var container = "_ld-4";
export var dismissButton = "_ld-3";
export var hasPaddingBottom = "_ld-6";
export var last = "_ld-e";
export var scrollbarThumb = "_ld-c";
export var scrollbarTrack = "_ld-b";
export var selected = "_ld-9";
export var spin = "_ld-1";
export var spinning = "_ld-0";
export var suggestionItem = "_ld-d";
export var suggestionsPanel = "_ld-5";
export var tonePill = "_ld-8";
export var tonesContainer = "_ld-7";
export var unselected = "_ld-a";